import * as React from "react";
import { AnimatePresence, motion } from "motion/react";
import { shuffleArray } from "../../utils/utils";
import { twMerge } from "tailwind-merge";

interface RotateWordsProps {
  text?: string;
  words: string[];
  className?: string;
}

export function RotateWords({ text, words, className }: RotateWordsProps) {
  const descriptions = shuffleArray(words);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % descriptions.length);
    }, 3000);
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [descriptions.length]);

  return (
    <div
      className={twMerge(` text-xl text-center sm:text-4xl font-bold tracking-tighter md:text-7xl md:leading-[4rem] w-fit flex items-center jusitfy-center mx-auto gap-1.5 `, className)}
    >
      {text && text}{" "}
      <AnimatePresence mode="wait">
        <motion.p
          key={descriptions[index]}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.5 }}
        >
          {descriptions[index]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
